import { useGrowl } from "PFApp/use_growl";
import { usePusherEvent } from "PFCore/base/pusher";
import isIOS from "PFCore/helpers/ios";
import isSafari from "PFCore/helpers/is_safari";
import { useCallback, useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

import AppContext from "../../app_context";

const useDownloadDocument = (generateDocument) => {
  const { t } = useTranslation("core");
  const {
    store: { currentProfile }
  } = useContext(AppContext);
  const growl = useGrowl();

  const timeoutID = useRef();

  const [state, setState] = useState({
    fileUrl: "",
    loading: false
  });

  const useAnchorTag = isIOS() || isSafari();

  useEffect(
    () => () => {
      clearTimeout(timeoutID.current);
    },
    []
  );

  const handleDownloadClick = (docType, ids = null) => {
    setState({ loading: true });
    generateDocument(docType, ids).success(handleDocGenerated).fail(handleDocFail);
  };

  const handleDocGenerated = useCallback(
    (response) => {
      if (typeof response === "string") {
        response = JSON.parse(response);
      }

      if (!response.file_url) {
        return;
      }

      $.ajax({
        url: response.file_url,
        api_version: 2
      }).then(
        (resp) => {
          setState({ fileUrl: resp.file_url, loading: false });

          if (useAnchorTag) {
            timeoutID.current = setTimeout(() => {
              setState({ fileUrl: "" });
            }, 10000);
          }
        },
        () => {
          setState({ loading: false });
          growl({ message: t("documentButtons.cannotBeOpen"), kind: "error" });
        }
      );
    },
    [growl, useAnchorTag]
  );

  const handleDocFail = (response) => {
    let message = t("documentButtons.fail.default");

    if (response.responseJSON) {
      const { errors } = response.responseJSON;
      message = errors[0].detail || t(errors[0].source.pointer.replace(/^\/data\/attributes\//, ""));
    }

    growl({
      kind: "error",
      title: t("documentButtons.failTitle"),
      message: message
    });

    setState({ loading: false });
  };

  usePusherEvent(`private-profile-${currentProfile.id}`, "file_generated", handleDocGenerated);

  return [handleDownloadClick, state.fileUrl, state.loading];
};

export default useDownloadDocument;
